export const transformCollectionPolicy = dto => ({
  canActivate: dto.can_activate,
  isPlanActivated: dto.plan_activated,
  maxItemCount: dto.max_item_count,
  maxActiveCollectionsCount: dto.max_active_collections_count
});